import env from '@/env';

type FeatureFlags =
    | boolean
    | undefined
    | {
          production?: boolean;
          staging?: boolean;
          develop?: boolean;
          development?: boolean;
      };

export function resolveRemoteConfig(flag: FeatureFlags): boolean {
    if (typeof flag === 'boolean') {
        return flag;
    }

    if (flag && typeof flag === 'object') {
        if (env.ENV === 'production') {
            return !!flag.production;
        }

        if (env.ENV === 'staging') {
            return !!flag.staging;
        }

        return !!(flag.develop ?? flag.development);
    }

    return false;
}
